<template>
  <div class="row">
    <main class="col-md-8 order-md-1 order-2">
      <div class="pb-3 mb-3">
        <span v-if="jobsRendered > 0">{{numResults}}</span>
        <span v-else-if="jobsRendered < 0">No</span>
        <span v-else>Finding</span>
        {{$store.state.search.keyword}} jobs in {{$store.state.search.location}}.
      </div>
      <div class="results mb-4 border-top"  v-if="jobsRendered > 0">
        <article class="job border-bottom featured" v-if="featuredJob">
          <a v-bind:href="featuredJob.click.parsed" @mousedown="recordJobClick(featuredJob)" class="position-relative" target="_blank">
            <div class="title h3">{{ featuredJob.title }}</div>
            <div class="description mb-3">{{ featuredJob.description }}</div>
            <div class="meta small">
              <ul class="d-flex list-inline m-0">
                <li class="list-inline-item"><i class="material-icons">location_city</i> {{ featuredJob.company }}</li>
                <li class="list-inline-item"><i class="material-icons">my_location</i> {{ featuredJob.location }}</li>
                <li class="list-inline-item"><i class="material-icons">update</i> {{ formatDate(featuredJob.date.timestamp) }}</li>
              </ul>
            </div>
          </a>
        </article>
        <article class="job border-bottom" v-for="job in jobs" v-bind:key="job.id">
          <a v-bind:href="job.click.parsed" @mousedown="recordJobClick(job)" class="position-relative" target="_blank">
            <div class="title h3">{{ job.title }}</div>
            <div class="description mb-3">{{ job.description }}</div>
            <div class="meta small">
              <ul class="d-flex list-inline m-0">
                <li class="list-inline-item"><i class="material-icons">location_city</i> {{ job.company }}</li>
                <li class="list-inline-item"><i class="material-icons">my_location</i> {{ job.location }}</li>
                <li class="list-inline-item"><i class="material-icons">update</i> {{ formatDate(job.date.timestamp) }}</li>
              </ul>
            </div>
          </a>
        </article>
      </div>
      <div class="results mb-4 border-top" v-else-if="jobsRendered < 0">
        <h1>We couldn't find what you were looking for... Try another search :D</h1>
      </div>
      <div class="results mb-4 border-top" v-else>
        <h1 class="font-weight-light"><div class="spinner-grow text-primary" role="status"><span class="sr-only">Loading...</span></div> Loading jobs...</h1>
      </div>
      <nav class="mt-4" v-if="jobsRendered > 0">
        <ul class="pagination m-0">
          <li class="page-item" v-bind:class="{ disabled: currentPage == '1' }">
            <a class="page-link" v-on:click.prevent="prevPage" href="#" tabindex="-1">Previous</a>
          </li>
          <li class="page-item" v-bind:class="{ disabled: currentPage == totalPages }">
            <a class="page-link" v-on:click.prevent="nextPage" href="#">Next</a>
          </li>
        </ul>
      </nav>
    </main>
    <aside class="col order-1">
      <div class="collapse filter-widget" id="filter-widget" v-bind:class="{ show: showFilters }">
        <h5>Search Radius</h5>
        <select class="w-100" v-on:change="filter" v-model="searchForm.distance">
          <option value="1">
            1 mile
          </option>
          <option value="5">
            5 miles
          </option>
          <option value="15">
            15 miles
          </option>
          <option value="30">
            30 miles
          </option>
          <option value="any">
            Any distance
          </option>
        </select>
      </div>
      <div class="m-0 p-4 text-center">
        <div id="jobsense1"></div>
      </div>
      <google-ad unit="MOVEOUTJOB_SITE" size="filter" class="google-ad-container"></google-ad>
    </aside>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
export default {
  name: 'Search',
  data () {
    return {
      showFilters: false,
      jobsRendered: 0,
      featuredJob: false,
      featuredJobKey: false,
      numResults: 0,
      totalPages: 0,
      jobs: [],
      widgetEl: false
    };
  },
  methods: {
    renderFeaturedJob (jobKey) {
      axios.get(
        process.env.VUE_APP_JOB_API + '/find-job',
        {
          params: {
            p: process.env.VUE_APP_JOB_PROVIDER,
            s: process.env.VUE_APP_SITE,
            k: jobKey,
            jobdesc: 1,
            striptags: 1,
            desclen: 500
          }
        }
      ).then(response => {
        const data = response.data.data;
        if (data.resultsLength > 0) {
          this.featuredJob = data.results[0];
        }
      }).catch(() => {
        this.featuredJob = false;
      });
    },
    renderJobs () {
      if (this.widgetEl) { this.widgetEl.remove(); }
      this.widgetEl = this.includeScript (`https://www.talent.com/jobsense/assets/jobsense.js.php?k=${this.$store.state.search.keyword}&l=${this.$store.state.search.location}&country=us&salary=1&direct=1&contenttype=all&size=8&publisher=3c507e0a98&chnl1=${process.env.VUE_APP_SITE}&chnl2=jrp&chnl3=right-rail&cpcfloor=20`);
      this.featuredJob = false;
      if (this.$route.query.k) {
        this.featuredJobKey = this.$route.query.k;
        this.renderFeaturedJob(this.featuredJobKey);
      }
      this.jobsRendered = 0;
      axios.get(
        process.env.VUE_APP_JOB_API + '/job',
        {
          params: {
            p: process.env.VUE_APP_JOB_PROVIDER,
            q: this.$store.state.search.keyword,
            l: this.$store.state.search.location,
            r: this.$store.state.search.distance,
            s: process.env.VUE_APP_SITE,
            pg: this.currentPage,
            cid: this.$store.state.user.cid,
            e: this.$store.state.user.email
          }
        }
      ).then(response => {  
        const data = response.data.data;
        this.totalPages = Math.ceil(data.total / data.resultsLength);
        this.jobsRendered = 1;
        this.numResults = data.total;
        this.jobs = data.results;
      }).catch(() => {
        this.jobsRendered = -1;
      });
    },
    prevPage () {
      this.$router.push({ name: 'search', params: {page: (parseInt(this.currentPage) - 1)}});
      this.renderJobs();
    },
    nextPage () {
      this.$router.push({ name: 'search', params: {page: (parseInt(this.currentPage) + 1)}});
      this.renderJobs();
    },
    filter () {
      this.updateSearch();
      if (this.currentPage > 1) {
        this.$router.replace({ params: { page: 1 } });
      }
      this.renderJobs();
    },
    toggleFilters () {
      this.showFilters = !this.showFilters;
    },
    formatDate (date) {
      return moment(date).fromNow();
    },
    jobIsNew (date) {
      const diff = moment(date).diff(Date.now(), 'days');
      return (diff >= -2);
    },
    handleJobClick (job) {
      const jsa = job.click.onmousedown.match(/&jsa=[0-9a-zA-Z]+/);
      let link = job.click.url + jsa[0];
  
      window.open(link, '_blank');
      this.recordJobClick(job);
    },
    recordJobClick (job) {
      axios.post(
        process.env.VUE_APP_METRICS_API + '/result-click',
        {
          campaign: {
              id: this.$store.state.user.cid
          },
          user: {
              email: this.$store.state.user.email,
              pid: this.$store.state.metrics.pid
          },
          search: {
              keyword: this.$store.state.search.keyword,
              location: this.$store.state.search.location,
              daysAgo: this.$store.state.search.age,
              radius: this.$store.state.search.distance,
              provider: process.env.VUE_APP_JOB_PROVIDER
          },
          page: {
              url: this.$route.fullPath,
              type: this.$route.name,
              viewId: this.$store.state.metrics.uuid
          },
          result: {
              title: job.title,
              company: job.company,
              location: job.location
          }
        }
      ).catch(e => {
        console.log(e);
      });
    }
  },
  computed: {
    currentPage () {
      return this.$route.params.page || 1;
    }
  },
  mounted () {
    this.updateSearch();
    this.renderJobs();
  }
}
</script>

<style scoped lang="scss">
  .page-item, .job {
    cursor: pointer;
  }

  .job {
    &.featured {
      a {
        padding: 20px;
        background: #340068;
        color: #fff;
        
        &:hover {
          background: #540088;
        }

        .title, .meta {
          color: #fff;
        }
        .badge {
          color: #fff;
        }
      }
    }
  }

  .google-ad-container {
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>
<style>
    .t-alternate-titles-container {
        box-sizing: border-box;
        font-family: 'Poppins', sans-serif;
        margin: 0;
        font-size: 13px;
        padding: 5px 0 5px 0;
        line-height: 1.4;
    }
    .t-alternate-titles-chevron {
        right: 25px;
        position: absolute;
        bottom: 16px;
        background-color: #F76352;
        color: #fff;
        font-weight: bold;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        text-align: center;
        padding: 4px;
    }
    .t-job-salary-urgent {
        color: #F76352;
        font-size: 11px;
        font-weight: 600;
    }
    .t-alternate-titles-salary-wrap {
        display: inline-block;
    }
    .t-block {
        display: block;
    }
    .t-alternate-titles {
        border: none;
        text-decoration: none;
        color: inherit;
        font-size: inherit;
        padding: 10px 20px 10px 20px;
        border-top: 1px solid #ECECEC;
        position: relative;
    }
    .t-alternate-titles-label {
        color: #000;
        font-weight: 600;
        font-size: 17px;
        width: 80%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .t-alternate-titles-salary-empname {
        width: 80%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color:#676767;
        font-size:12px;
    }
    /* End Job Sense Styles */
</style>
